module.exports = __webpack_public_path__ + "static/img/wh.df5e3b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wh.jpg
// module id = JrB9
// module chunks = 1